import {Injectable} from '@angular/core';
import {Headers, Http, RequestOptions} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {Router} from '@angular/router';
import {ApiConstants, CustomHttp} from '../../shared';
import * as _ from 'lodash';
import {add} from 'ngx-bootstrap/chronos';
import CommonUtils from '../../shared/common.util';


@Injectable()
export class CatalogService {
    private META_DATA_URL = 'metadata/tv?key=gx4tG2hALXWgQt7o4YTU&query=';
    private META_DATA_ENTENDED_URL = '&extended=true&internal=true&images=true';
    private CONTENT_TYPE_ENTENDED_URL = '&specifiedContentType=';
    private MISSING_IMAGES_URL = 'catalog/tv?sortby=start_date&orderby=asc&images=true&images_missing=true';
    private ALL_CATALOG_URL = 'catalog/tv?internal=true&images=true';
    private JUSTWATCH_ID = 'catalog/id';
    private VERIFICATION_STATUS_UPDATE_URL = 'verification_status/';
    private GENOME_UPDATE_URL = 'genes_update';
    private GENOME_NOTE_URL = 'enrich/note';
    private WIKI_URL = 'wikipedia?fullRefresh=true';
    private DAILY_INFOHASH_CHECK_URL = 'daily_title_infohash_check';
    private DATAHEALTH_MAPPINGS_URL = 'datahealth';
    private TITLE_NAME_CHANGE_URL = 'enrich/updatetitles/tv';
    private META_DATA_CONTENT_TYPE_URL = 'metadata/';
    private QUERY_PARAM = '?key=gx4tG2hALXWgQt7o4YTU&query=';

    private ES_GLOBAL_QUERY = {
        'id': '',
        'params': {
            'search_str': '',
            'search_market': 'WW',
            'from': 0,
            'size': ''
        }
    };

    private ES_LOADMETADATA_QUERY = {
        'query': {
            'bool': {
                'should': [
                    {
                        'match': {
                            'data.external_mappings.wiki_id': ''
                        }

                    },
                    {
                        'match': {
                            'data.external_mappings.imdb_id': ''
                        }

                    },
                    {
                        'match': {
                            'data.external_mappings.wikibase_id': ''
                        }

                    }
                ]
            }
        }
    };


    private ES_GET_EXTRA_QUERY_FIELDS = {
        'query': {
            'bool': {
                'must': [
                    {
                        'term': {
                            'parrot_id': ''
                        }
                    }
                ]
            }
        }
    };

    private ES_QUERY_OBJECT_HARVESTING = {
        'query': {
            'bool': {
                'must': [
                    {
                        'multi_match': {
                            'query': '',
                            'type': 'best_fields',
                            'fields': [
                                'title',
                                'display_name',
                                'parrot_id',
                                'data.also_known_as^1.3',
                                'data.external_mappings.*',
                                'extended.tms.tms_id',
                                'extended.wiki.wikibase_id',
                                'extended.wiki.langlinks.title',
                                'extended.wiki.langlinks.url',
                                'extended.wiki.title',
                            ],
                            'minimum_should_match': 1,
                            'fuzziness': 0.5,
                            'prefix_length': 3,
                            'slop': 3
                        }
                    }
                ]
            }
        },
        'timeout': '7s',
        '_source': [],
        'size': 1000
    };

    private ADDITIONL_FILTER_OBJECT = {

        'bool': {

            'should': []

        }

    };

    private ES_QUERY_OBJECT_NEW = {
        'query': {
            'function_score': {
                'query': {
                    'bool': {
                        'must': [
                            {
                                'terms': {
                                    'catalog_state': ''
                                }
                            },
                            {
                                'bool': {
                                    'should': [
                                        {
                                            'multi_match': {
                                                'query': '',
                                                'type': 'phrase_prefix',
                                                'fields': [
                                                    'title.search^1.1',
                                                    'title.search._2gram',
                                                    'title.search._3gram',
                                                    'display_name.search',
                                                    'display_name.search._2gram',
                                                    'display_name.search._3gram',
                                                    'data.also_known_as.search',
                                                    'data.also_known_as',
                                                    'data.also_known_as.search._2gram',
                                                    'data.also_known_as.search._3gram'
                                                ]
                                            }
                                        },
                                        {
                                            'multi_match': {
                                                'query': '',
                                                'type': 'phrase',
                                                'fields': [
                                                    'short_id',
                                                    'parrot_id',
                                                    'data.external_mappings.imdb_id',
                                                    'data.external_mappings.netflix_id',
                                                    'data.external_mappings.wiki_id',
                                                    'data.external_mappings.wikibase_id',
                                                    'data.external_mappings.hulu_id',
                                                    'data.external_mappings.tmdb_id',
                                                    'data.external_mappings.tvdb_id',
                                                ]
                                            }
                                        }
                                    ]
                                }
                            }
                        ]
                    }
                },
                'field_value_factor': {
                    'field': 'demand.WW',
                    'factor': 1.7,
                    'modifier': 'sqrt',
                    'missing': 1
                },
                'score_mode': 'sum'
            }
        },
        'sort': '',
        '_source': [],
        'highlight': {
            'fields': {
                'display_name': {}
            }
        },
        'timeout': '30s',
        'from': '',
        'size': ''
    };


    private ES_QUERY_BUSINESS_OPERATIONS = {
        'query': {
            'multi_match': {
                'query': '',
                'fields': ['industry_segment^3', 'business_question'],
                'type': 'best_fields',
                'fuzziness': 'AUTO'
            }
        }, 'size': 1000
    };

    private ES_QUERY_JUSTWATCH_METADATA = {
        'query': {
            'bool': {
                'must': [
                    {
                        'term': {
                            'justwatch_id': ''
                        }
                    }
                ]
            }
        },
        'size': 200
    };

    private JUSTWATCH_QUERY = {
        'justwatch_url' : ''
    };


    private ES_DIRECT_QUERY_OBJECT = {
        'query': {
            'function_score': {
                'query': {
                    'bool': {
                        'must': [
                            {
                                'bool': {
                                    'must': [
                                        {
                                            'terms': {
                                                'catalog_state': ''
                                            }
                                        }
                                    ]
                                }
                            }
                        ]
                    }
                },
                'field_value_factor': {
                    'field': 'demand.US',
                    'factor': 1.7,
                    'modifier': 'sqrt',
                    'missing': 1
                },
                'score_mode': 'sum'
            }
        },
        'sort': '',
        '_source': [],
        'highlight': {
            'fields': {
                'display_name': {}
            }
        },
        'timeout': '30s',
        'from': '',
        'size': ''
    };


    private ES_QUERY_OBJECT = {
        'query': {
            'bool': {
                'must': [
                    {
                        'multi_match': {
                            'query': '',
                            'type': 'best_fields',
                            'fields': [
                                'title',
                                'display_name',
                                'parrot_id',
                                'data.also_known_as^1.3',
                                'data.external_mappings.*',
                                'extended.tms.tms_id',
                                'extended.wiki.wikibase_id',
                                'extended.wiki.langlinks.title',
                                'extended.wiki.langlinks.url',
                                'extended.wiki.title',
                            ],
                            'minimum_should_match': 1,
                            'fuzziness': 0.5,
                            'prefix_length': 3,
                            'slop': 3
                        }
                    }
                ]
            }
        },
        'timeout': '7s',
        '_source': [],
        'size': 15
    };
    private ES_IMDB_QUERY_OBJECT = {
        'query': {
            'bool': {
                'must': [
                    {
                        'multi_match': {
                            'query': '',
                            'type': 'best_fields',
                            'fields': [
                                'Title',
                                'AKAs.AKA.Title'
                            ],
                            'minimum_should_match': 1,
                            'fuzziness': 1,
                            'prefix_length': 3,
                            'slop': 3
                        }
                    }
                ]
            }
        },
        'timeout': '7s',
        '_source': [],
        'size': 15
    };
    private ES_DEFAULT_SOURCE = [
        'title', 'parrot_id', 'display_name', 'catalog_state', 'internal_data',
        'data.release_year', 'data.type', 'data.original_country', 'data.original_network',
        'data.original_language', 'data.short_description', 'data.also_known_as', 'verification_status',
        'data.external_mappings', 'data.genre_tags', 'data.total_seasons', 'data.total_episodes', 'data.production_company', 'data.distribution_company', 'data.birth_year',
        'data.sports'
    ];
    private ES_SORT_BY_PRIORITY = {
        '_script': {
            'type': 'number',
            'script': {
                'lang': 'painless',
                'source': 'if (doc.containsKey(\'internal_data.priority.keyword\') && !doc[\'internal_data.priority.keyword\'].empty) ' +
                    '{if (doc[\'internal_data.priority.keyword\'].value.toLowerCase() == \'high\') {return 3;} ' +
                    'else if (doc[\'internal_data.priority.keyword\'].value.toLowerCase() == \'medium\') {return 2;}' +
                    'else if (doc[\'internal_data.priority.keyword\'].value.toLowerCase() == \'low\') {return 1;} else {return 0;}} else {return 0;}'
            },
            'order': 'desc'
        }
    };

    constructor(private router: Router, private http: Http,
                private ApiConstants: ApiConstants, private customHttp: CustomHttp) {
    }

    getBaseUrl() {
        return this.ApiConstants.CATALOG_API_URL;
    }

    getHelpdeskUrl() {
        return this.ApiConstants.HELPDESK_API_URL;
    }

    getBaseESIndex() {
        return this.ApiConstants.ES_SERVICE;
    }

    getESProxyUrl(index: string) {
        const baseURL = this.getBaseUrl().replace('catalogapi', 'helpdeskapi');
        return `${baseURL.replace('/v1', '')}proxy?service=${this.getBaseESIndex()}&uri=/${index}/_search`;
    }

    getESProxyDevUrl(index: string) {
        const baseURL = this.getBaseUrl().replace('catalogapi', 'helpdeskapi');
        return `${baseURL.replace('/v1', '')}proxy?service=${this.getBaseESIndex()}&env=dev&uri=/${index}/_search`;
    }

    getESProxyProdUrl(index: string) {
        const baseURL = this.getBaseUrl().replace('catalogapi', 'helpdeskapi');
        return `${baseURL.replace('/v1', '')}proxy?service=${this.getBaseESIndex()}&env=prod&uri=/${index}/_search`;
    }

    getGlobalESProxyUrl(index: string, template: string) {
        const baseURL = this.getBaseUrl().replace('catalogapi', 'helpdeskapi');
        return `${baseURL.replace('/v1', '')}proxy?service=${this.getBaseESIndex()}&uri=/${index}/_search/${template}`;
    }

    getBusinessOperationsESProxyUrl(index: string) {
        const baseURL = this.getBaseUrl().replace('catalogapi', 'helpdeskapi');
        return `${baseURL.replace('/v1', '')}proxy?service=${this.getBaseESIndex()}&env=dev&uri=/${index}/_search`;
    }

    getJustwatchESProxyUrl(index: string) {
        const baseURL = this.getBaseUrl().replace('catalogapi', 'helpdeskapi');
        return `${baseURL.replace('/v1', '')}proxy?service=${this.getBaseESIndex()}&env=dev&uri=/${index}/_search`;
    }


    getEsDefaultSource() {
        return _.cloneDeep(this.ES_DEFAULT_SOURCE);
    }

    getEsQueryObject() {
        return _.cloneDeep(this.ES_QUERY_OBJECT);
    }

    getHarvestingEsQueryObject() {
        return _.cloneDeep(this.ES_QUERY_OBJECT_HARVESTING);
    }

    getEsImdbQueryObject() {
        return _.cloneDeep(this.ES_IMDB_QUERY_OBJECT);
    }

    getESPrioritySortObject() {
        return _.cloneDeep(this.ES_SORT_BY_PRIORITY);
    }

    getCatalogMetadata(query: string, content_type) {
        const url = `${this.getBaseUrl()}${this.META_DATA_CONTENT_TYPE_URL}${content_type}` + `${this.QUERY_PARAM}${query}` + this.META_DATA_ENTENDED_URL;

        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        return this.http.get(url, {headers: headers, body: ''})
            .map(res => res.json())
            .toPromise()
            .catch(error => error);
    }

    getCatalog(query: string) {
        const url = `${this.getBaseUrl()}${this.META_DATA_URL}${query}` + this.META_DATA_ENTENDED_URL;
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        return this.http.get(url, {headers: headers, body: ''})
            .map(res => res.json())
            .toPromise()
            .catch(error => error);
    }

    getCatalogByContentType(query: string, contentType) {
        let url = `${this.getBaseUrl()}${this.META_DATA_URL}${query}` + this.META_DATA_ENTENDED_URL;
        url = url.replace('/tv?', '/' + contentType + '?');

        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        return this.http.get(url, {headers: headers, body: ''})
            .map(res => res.json())
            .toPromise()
            .catch(error => error);
    }

    getCatalogMissingImages() {
        const url = this.getBaseUrl() + this.MISSING_IMAGES_URL;
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        return this.http.get(url, {headers: headers, body: ''})
            .map(res => res.json())
            .toPromise()
            .catch(error => console.log(error));
    }

    getContentType(contentType) {
        if ( contentType.toLowerCase() !== 'movie' && contentType.toLowerCase() !== 'talent')
            // tslint:disable-next-line:one-line
        {
            return 'SHOW';
        }
        return contentType.toUpperCase();
    }

    updateVerificationStatus(parrotId, verificationStatus, contentType, imdbId, userInputText: string) {

        const payload = {
            'parrot_id' : parrotId,
            'imdb_id' : imdbId ? imdbId : '',
            'verification_status' : verificationStatus,
            'updated_by' : localStorage.getItem('userName'),
            'redirect_to_parrot_id' : userInputText ? userInputText : '',
        };

        const url = this.getBaseUrl() + this.VERIFICATION_STATUS_UPDATE_URL + this.getContentType(contentType);
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        const options = new RequestOptions({headers: headers});
        return this.http.post(url, JSON.stringify(payload), options)
            .map(res => res.json())
            .toPromise()
            .catch(error => console.log(error));
    }


    refreshWiki() {
        const url = this.getBaseUrl() + this.WIKI_URL; // `https://catalogapi.parrotanalytics.com/v1/catalog/tv`;
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        return this.http.get(url, {headers: headers, body: ''})
            .map(res => res.json())
            .toPromise()
            .catch(error => error);
    }

    getAllCatalogue() {
        const url = this.getBaseUrl() + this.ALL_CATALOG_URL; // `https://catalogapi.parrotanalytics.com/v1/catalog/tv`;
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        return this.http.get(url, {headers: headers, body: ''})
            .map(res => res.json())
            .toPromise()
            .catch(error => console.log(error));
    }

    createYoutubeSearchTerm(parrotId: any, content_type) {
        if ( content_type === 'movie' ) {
            const url = this.getBaseUrl() + 'datahealth/' + parrotId + '/' + 'MOVIE'; // `https://catalogapi.parrotanalytics.com/v1/datahealth/{PID}/movie`;
            const headers = new Headers();
            this.createAuthorizationHeader(headers);
            return this.http.put(url, {headers: headers, body: ''})
                .map(res => res.json())
                .toPromise()
                .catch(error => console.log(error));
        }
    }

    createAuthorizationHeader(headers: Headers) {
        headers.append('x-auth-token', localStorage.getItem('id_token'));
        headers.append('Content-Type', 'application/json');
        return headers;
    }

    updateGenome(selectedTitles: Array<string>, gene: Array<string>, values: Array<string>, contentType) {
        return new Promise((resolve, reject) => {
            const updateGenesList = selectedTitles.map((parrotId, index) => {
                return {
                    'parrot_id': parrotId,
                    'gene': gene[index],
                    'source': 'manual',
                    'value': values[index]
                };
            });
            const genomePayload = updateGenesList;
            this._updateGenome(genomePayload, contentType)
                .then((res) => {
                    resolve(res);
                })
                .catch((err) => {
                    console.error('Error trying to update the data state genome to customer ready: ' +
                        err.toString());
                    reject(err);
                });
        });
    }

    updateGenomeDeprecated(payload, contentType) {
        payload = payload['updateGenesList'];
        return this._updateGenome(payload, contentType);
    }

    private _updateGenome(payload, contentType) {
        // Hacky method to avoid having to move and change everything.
        const user = localStorage.getItem('userName');
        const uri = '/' + this.GENOME_UPDATE_URL + '?user=' + user + '&content_type=' + contentType;

        return this.customHttp.post(uri, JSON.stringify(payload));
    }

    updateNotes(payload, operation?) {
        let url = this.getBaseUrl() + this.GENOME_NOTE_URL;
        if (operation) {
            url += '/' + operation;
        }
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        const options = new RequestOptions({headers: headers});
        return this.http.post(url, JSON.stringify(payload), options)
            .map(res => res.json())
            .toPromise()
            .catch(error => console.log(error));
    }

    createCatalogTypeFilters(typeFilters: string[] = []) {
        return typeFilters.map((filter) => {
            return {
                'term': {
                    'data.type': filter
                }
            };
        });
    }

    createImdbTypeFilters(typeFilters: string[] = []) {
        return typeFilters.map((filter) => {
            return {
                'match_phrase': {
                    'TitleType': {
                        'query': filter
                    }
                }
            };
        });
    }

    createMultiMatchObject(matchType: string, fields: string[], query: string,
                           additionalItems?: { [s: string]: string; }) {
        return {
            'multi_match': {
                'query': query,
                'type': matchType,
                'fields': fields,
                ...additionalItems
            }
        };
    }

    createExtendedMultiMatchObject(matchType: string, fields: string[], query: string,
                                   additionalItems?: { [s: string]: string; }) {
        return {
            'multi_match': {
                'query': query,
                'type': matchType,
                'fields': fields,
                ...additionalItems
            }
        };
    }

    // tslint:disable-next-line:one-line
    createGlobalSearchEsQuery(title: string, words: any, searchIndex: string, size: any) {
        const request = _.cloneDeep(this.ES_GLOBAL_QUERY);
        request.params.search_str = title;
        request.params.size = size;
        request.id = searchIndex;

        console.log(JSON.stringify(request));
        return JSON.stringify(request);
    }

    createBusinessOperationsEsQuery(title: string) {
        const request = _.cloneDeep(this.ES_QUERY_BUSINESS_OPERATIONS);
        request.query.multi_match.query = title;
        console.log(JSON.stringify(request));
        return JSON.stringify(request);
    }

    createJustwatchEsQuery(title: string) {
        const request = _.cloneDeep(this.ES_QUERY_JUSTWATCH_METADATA);
        request.query.bool.must[0].term.justwatch_id = title;
        console.log(JSON.stringify(request));
        return JSON.stringify(request);
    }

    createJustwatchQuery(title: string) {
        const request = _.cloneDeep(this.JUSTWATCH_QUERY);
        request.justwatch_url = title;
        return JSON.stringify(request);
    }

    // tslint:disable-next-line:max-line-length
    createEsQuery(queryTerm: string, size: number = 15, typeFilters: string[] = [], originalFilters = {}, source: string[] = this.ES_DEFAULT_SOURCE, indexType: 'catalog' | 'imdb' = 'catalog', from: number = 0) {
        const request = indexType === 'catalog' ? _.cloneDeep(this.ES_QUERY_OBJECT) : _.cloneDeep(this.ES_IMDB_QUERY_OBJECT);
        request.query.bool.must[0].multi_match.query = queryTerm;
        request.size = size;
        if (originalFilters && indexType === 'catalog') {
            if (!queryTerm || queryTerm === '') {
                // If there is no query term, we want to remove the first multimatch object
                request.query.bool.must = [];
            }
            request.query.bool.must = request.query.bool.must.concat(
                Object.keys(originalFilters).map((key) => {
                    const value = originalFilters[key];
                    return this.createMultiMatchObject('phrase', [key], value);
                })
            );
        }

        if (typeFilters) {
            // if (indexType === 'catalog') {
            //   request.query.bool.must = request.query.bool.must.concat(
            //     {
            //       'bool': {
            //         'should': this.createCatalogTypeFilters(typeFilters)
            //       }
            //     }
            //   );
            // } else
            if (indexType === 'imdb') {
                request.query.bool.must = request.query.bool.must.concat(
                    {
                        'bool': {
                            'should': this.createImdbTypeFilters(typeFilters)
                        }
                    }
                );
            }
        }
        request._source = source;
        request.from = from;
        return JSON.stringify(request);
    }

    createBulkInfohashDemandEsQuery(catalogState, titleSearch: boolean, queryTerm: string, size: number = 50, source: string[] = this.ES_DEFAULT_SOURCE, from: number = 0, contentType) {
        const request =  _.cloneDeep(this.ES_QUERY_OBJECT_NEW);

        request.query.function_score.query.bool.must[1].bool.should[0].multi_match.query = queryTerm;
        request.query.function_score.query.bool.must[1].bool.should[1].multi_match.query = queryTerm;
        request.query.function_score.query.bool.must[0].terms.catalog_state = catalogState;

        if (contentType !== 'movie') {
            const sortValue = [
                {
                    'demand.US': {
                        'order': 'desc'
                    }
                }
            ];
            request.sort = sortValue;
        } else {
            const sortValue = [
                {
                    'catalog_state': {
                        'order': 'asc'
                    }
                }
            ];
            request.sort = sortValue;
        }

        request.size = size;
        request._source = source;
        request.from = from;
        return JSON.stringify(request);
    }

    // tslint:disable-next-line:max-line-length
    createDemandEsQuery(catalogState, titleSearch: boolean, queryTerm: string, size: number = 15, typeFilters: string[] = [], originalFilters = {}, source: string[] = this.ES_DEFAULT_SOURCE, indexType: 'catalog' | 'imdb' = 'catalog', from: number = 0, contentType) {
        const request = indexType === 'catalog' ? _.cloneDeep(this.ES_QUERY_OBJECT_NEW) : _.cloneDeep(this.ES_IMDB_QUERY_OBJECT);

        request.query.function_score.query.bool.must[1].bool.should[0].multi_match.query = queryTerm;
        request.query.function_score.query.bool.must[1].bool.should[1].multi_match.query = queryTerm;
        request.query.function_score.query.bool.must[0].terms.catalog_state = catalogState;

        const emptyList = [];


        if (originalFilters) {
            const additionalFilters = [];
            Object.keys(originalFilters).map((key) => {
                const value = originalFilters[key];
                if (key.includes('original_country')) {
                    const additionalRequest = _.cloneDeep(this.ADDITIONL_FILTER_OBJECT);
                    for (let i = 0; i <= 6; i++) {
                        additionalRequest.bool.should = additionalRequest.bool.should.concat(this.additionalFilterTermQuery(value, 'data.original_country.' + i));
                    }
                    request.query.function_score.query.bool.must = request.query.function_score.query.bool.must.concat(additionalRequest);
                }
                if (key.includes('original_language')) {
                    const additionalRequest = _.cloneDeep(this.ADDITIONL_FILTER_OBJECT);

                    for (let i = 0; i <= 6; i++) {
                        // tslint:disable-next-line:max-line-length
                        additionalRequest.bool.should = additionalRequest.bool.should.concat(this.additionalFilterTermQuery(value, 'data.original_language.' + i));
                    }
                    request.query.function_score.query.bool.must = request.query.function_score.query.bool.must.concat(additionalRequest);

                }
                if (contentType !== 'movie') {
                    if (key.includes('original_network')) {
                        const additionalRequest = _.cloneDeep(this.ADDITIONL_FILTER_OBJECT);

                        for (let i = 0; i <= 6; i++) {
                            // tslint:disable-next-line:max-line-length
                            additionalRequest.bool.should = additionalRequest.bool.should.concat(this.additionalFilterTermQuery(value, 'data.original_network.' + i));
                        }
                        request.query.function_score.query.bool.must = request.query.function_score.query.bool.must.concat(additionalRequest);

                    }
                } else {
                    if (key.includes('original_network')) {
                        let additionalRequest = _.cloneDeep(this.ADDITIONL_FILTER_OBJECT);

                        for (let i = 0; i <= 6; i++) {
                            // tslint:disable-next-line:max-line-length
                            additionalRequest.bool.should = additionalRequest.bool.should.concat(this.additionalFilterTermQuery(value, 'data.production_company.' + i));
                        }
                        request.query.function_score.query.bool.must = request.query.function_score.query.bool.must.concat(additionalRequest);

                        additionalRequest = _.cloneDeep(this.ADDITIONL_FILTER_OBJECT);

                        for (let i = 0; i <= 6; i++) {
                            // tslint:disable-next-line:max-line-length
                            additionalRequest.bool.should = additionalRequest.bool.should.concat(this.additionalFilterTermQuery(value, 'data.distribution_company.' + i));
                        }
                        request.query.function_score.query.bool.must = request.query.function_score.query.bool.must.concat(additionalRequest);

                    }
                }
            });
        }

        if (contentType !== 'movie' && contentType !== 'sports') {
            const sortValue = [
                {
                    'demand.US': {
                        'order': 'desc'
                    }
                }
            ];
            request.sort = sortValue;
        } else {
            const sortValue = [
                {
                    'catalog_state': {
                        'order': 'asc'
                    }
                }
            ];
            request.sort = sortValue;
        }

        request.size = size;
        request._source = source;
        request.from = from;
        return JSON.stringify(request);
    }

    createTermObject(searchTerm) {
        const value = {
            'bool': {
                'must': [
                    {
                        'term': {
                            'title.keyword': searchTerm
                        }
                    }
                ]
            }
        };
        return value;
    }

    createDirectEsQuery(catalogState, titleSearch: boolean, queryTerm: string, size: number = 15, typeFilters: string[] = [], originalFilters = {}, source: string[] = this.ES_DEFAULT_SOURCE, indexType: 'catalog' | 'imdb' = 'catalog', from: number = 0, contentType) {
        const request = indexType === 'catalog' ? _.cloneDeep(this.ES_DIRECT_QUERY_OBJECT) : _.cloneDeep(this.ES_IMDB_QUERY_OBJECT);
        request.query.function_score.query.bool.must[0].bool.must[0].terms.catalog_state = catalogState;
        request.query.function_score.query.bool.must =
            request.query.function_score.query.bool.must.concat(this.createTermObject(queryTerm));

        const emptyList = [];


        if (originalFilters) {
            const additionalFilters = [];
            Object.keys(originalFilters).map((key) => {
                const value = originalFilters[key];
                if (key.includes('original_country')) {
                    const additionalRequest = _.cloneDeep(this.ADDITIONL_FILTER_OBJECT);
                    for (let i = 0; i <= 6; i++) {
                        additionalRequest.bool.should = additionalRequest.bool.should.concat(this.additionalFilterTermQuery(value, 'data.original_country.' + i));
                    }
                    request.query.function_score.query.bool.must = request.query.function_score.query.bool.must.concat(additionalRequest);
                }
                if (key.includes('original_language')) {
                    const additionalRequest = _.cloneDeep(this.ADDITIONL_FILTER_OBJECT);

                    for (let i = 0; i <= 6; i++) {
                        // tslint:disable-next-line:max-line-length
                        additionalRequest.bool.should = additionalRequest.bool.should.concat(this.additionalFilterTermQuery(value, 'data.original_language.' + i));
                    }
                    request.query.function_score.query.bool.must = request.query.function_score.query.bool.must.concat(additionalRequest);

                }
                if (contentType !== 'movie') {
                    if (key.includes('original_network')) {
                        const additionalRequest = _.cloneDeep(this.ADDITIONL_FILTER_OBJECT);

                        for (let i = 0; i <= 6; i++) {
                            // tslint:disable-next-line:max-line-length
                            additionalRequest.bool.should = additionalRequest.bool.should.concat(this.additionalFilterTermQuery(value, 'data.original_network.' + i));
                        }
                        request.query.function_score.query.bool.must = request.query.function_score.query.bool.must.concat(additionalRequest);

                    }
                } else {
                    if (key.includes('original_network')) {
                        let additionalRequest = _.cloneDeep(this.ADDITIONL_FILTER_OBJECT);

                        for (let i = 0; i <= 6; i++) {
                            // tslint:disable-next-line:max-line-length
                            additionalRequest.bool.should = additionalRequest.bool.should.concat(this.additionalFilterTermQuery(value, 'data.production_company.' + i));
                        }
                        request.query.function_score.query.bool.must = request.query.function_score.query.bool.must.concat(additionalRequest);

                        additionalRequest = _.cloneDeep(this.ADDITIONL_FILTER_OBJECT);

                        for (let i = 0; i <= 6; i++) {
                            // tslint:disable-next-line:max-line-length
                            additionalRequest.bool.should = additionalRequest.bool.should.concat(this.additionalFilterTermQuery(value, 'data.distribution_company.' + i));
                        }
                        request.query.function_score.query.bool.must = request.query.function_score.query.bool.must.concat(additionalRequest);

                    }
                }
            });
        }

        if (contentType !== 'movie' && contentType !== 'sports') {
            const sortValue = [
                {
                    'demand.US': {
                        'order': 'desc'
                    }
                }
            ];
            request.sort = sortValue;
        } else {
            const sortValue = [
                {
                    'catalog_state': {
                        'order': 'asc'
                    }
                }
            ];
            request.sort = sortValue;
        }

        request.size = size;
        request._source = source;
        request.from = from;
        return JSON.stringify(request);
    }

    createBulkInfohashDirectEsQuery(catalogState, titleSearch: boolean, queryTerm: string, size: number = 50, source: string[] = this.ES_DEFAULT_SOURCE, from: number = 0, contentType) {
        const request =  _.cloneDeep(this.ES_QUERY_OBJECT_NEW);

        request.query.function_score.query.bool.must[1].bool.should[0].multi_match.query = queryTerm;
        request.query.function_score.query.bool.must[1].bool.should[1].multi_match.query = queryTerm;
        request.query.function_score.query.bool.must[0].terms.catalog_state = catalogState;

        if (contentType !== 'movie') {
            const sortValue = [
                {
                    'demand.US': {
                        'order': 'desc'
                    }
                }
            ];
            request.sort = sortValue;
        } else {
            const sortValue = [
                {
                    'catalog_state': {
                        'order': 'asc'
                    }
                }
            ];
            request.sort = sortValue;
        }

        request.size = size;
        request._source = source;
        request.from = from;
        return JSON.stringify(request);
    }

    // tslint:disable-next-line:max-line-length
    createSupplyEsQuery(titleSearch: boolean, queryTerm: string, size: number = 15, typeFilters: string[] = [], originalFilters = {}, source: string[] = this.ES_DEFAULT_SOURCE, indexType: 'catalog' | 'imdb' = 'catalog', from: number = 0) {
        const request = indexType === 'catalog' ? _.cloneDeep(this.ES_QUERY_OBJECT) : _.cloneDeep(this.ES_IMDB_QUERY_OBJECT);
        request.query.bool.must[0].multi_match.query = queryTerm;
        request.size = size;
        if (originalFilters && indexType === 'catalog') {
            if (!queryTerm || queryTerm === '') {
                // If there is no query term, we want to remove the first multimatch object
                request.query.bool.must = [];
            }
            request.query.bool.must = request.query.bool.must.concat(
                Object.keys(originalFilters).map((key) => {
                    const value = originalFilters[key];
                    return this.createMultiMatchObject('phrase', [key], value);
                })
            );
        }
        if (titleSearch) {
            request.query.bool.must = request.query.bool.must.concat(
                {
                    'bool': {
                        'should': [
                            {
                                'terms': {
                                    'catalog_state': ['metadata_ready']
                                }
                            }
                        ]
                    }
                }
            );
        } else {
            request.query.bool.must = request.query.bool.must.concat(
                {
                    'bool': {
                        'should': [
                            {
                                'terms': {
                                    'catalog_state': ['metadata_ready', 'requested', 'harvested', 'client_ready', 'demand_generation']
                                }
                            }
                        ]
                    }
                }
            );
        }
        if (typeFilters) {
            // if (indexType === 'catalog') {
            //   request.query.bool.must = request.query.bool.must.concat(
            //     {
            //       'bool': {
            //         'should': this.createCatalogTypeFilters(typeFilters)
            //       }
            //     }
            //   );
            // } else
            if (indexType === 'imdb') {
                request.query.bool.must = request.query.bool.must.concat(
                    {
                        'bool': {
                            'should': this.createImdbTypeFilters(typeFilters)
                        }
                    }
                );
            }
        }
        request._source = source;
        request.from = from;
        return JSON.stringify(request);
    }

    callEsProxyCustomQuery(query: string, index = 'series_metadata') {
        const url = this.getESProxyUrl(index);
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        const options = new RequestOptions({headers: headers});
        return this.http.post(url, query, options)
            .map(res => res.json())
            .toPromise()
            .catch(error => console.log(error));
    }

    callEsProd(query: string, index = 'series_metadata') {
        const url = this.getESProxyProdUrl(index);
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        const options = new RequestOptions({headers: headers});
        return this.http.post(url, query, options)
            .map(res => res.json())
            .toPromise()
            .catch(error => console.log(error));
    }

    callEsProxyCustomQueryFromInfohash(query: string, index) {
        const url = this.getESProxyUrl(index);
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        const options = new RequestOptions({headers: headers});
        return this.http.post(url, query, options)
            .map(res => res.json())
            .toPromise()
            .catch(error => console.log(error));
    }

    callEsProxyLoadMetaData(query: string, index) {
        const url = this.getESProxyProdUrl(index);
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        const options = new RequestOptions({headers: headers});
        return this.http.post(url, query, options)
            .map(res => res.json())
            .toPromise()
            .catch(error => console.log(error));
    }

    callEsProxyCustomQueryNewMetadata(query: string, index) {
        const url = this.getESProxyDevUrl(index);
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        const options = new RequestOptions({headers: headers});
        return this.http.post(url, query, options)
            .map(res => res.json())
            .toPromise()
            .catch(error => console.log(error));
    }

    callEsProxyBusinessOperationsQueryMetadata(query: string, index) {
        const url = this.getESProxyDevUrl(index);
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        const options = new RequestOptions({headers: headers});
        return this.http.post(url, query, options)
            .map(res => res.json())
            .toPromise()
            .catch(error => console.log(error));
    }

    callEsProxybasedOnParrotIDQuery(query: string, index = 'master_tv_catalog') {
        const url = this.getESProxyUrl(index);
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        const options = new RequestOptions({headers: headers});
        return this.http.post(url, query, options)
            .map(res => res.json())
            .toPromise()
            .catch(error => console.log(error));
    }

    callGlobalSearchEsProxyCustomQuery(query: string, index = 'series_metadata', template: string) {
        const url = this.getGlobalESProxyUrl(index, template);
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        const options = new RequestOptions({headers: headers});
        return this.http.post(url, query, options)
            .map(res => res.json())
            .toPromise()
            .catch(error => console.log(error));
    }

    callBusinessOperationsEsProxyCustomQuery(query: string, index = 'series_metadata') {
        const url = this.getBusinessOperationsESProxyUrl(index);
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        const options = new RequestOptions({headers: headers});
        return this.http.post(url, query, options)
            .map(res => res.json())
            .toPromise()
            .catch(error => console.log(error));
    }

    callJustwatchEndpoint(query: string, index = 'series_metadata') {
        const url = this.getBaseUrl() + this.JUSTWATCH_ID; // `https://catalogapi.parrotanalytics.com/v1/catalog/id`;
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        const options = new RequestOptions({headers: headers});
        return this.http.post(url, query, options)
            .map(res => res.json())
            .toPromise()
            .catch(error => console.log(error));
    }

    callJustwatchESEndpoint(query: string, index = 'series_metadata') {
        const url = this.getJustwatchESProxyUrl(index);
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        const options = new RequestOptions({headers: headers});
        return this.http.post(url, query, options)
            .map(res => res.json())
            .toPromise()
            .catch(error => console.log(error));
    }

    createBusinessSolutionAPI(searchTerm) {
            const url = this.getBaseUrl().replace('/v1', '') + 'businesssolutions?query=' + searchTerm;
            const headers = new Headers();
            this.createAuthorizationHeader(headers);
            const options = new RequestOptions({headers: headers});
            return this.http.get(url, options)
                .map(res => res.json())
                .toPromise();
    }

    callEsProxySeriesMetadataQuery(query: string, index = 'series_metadata') {
        const url = this.getESProxyUrl(index);
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        const options = new RequestOptions({headers: headers});
        return this.http.post(url, query, options)
            .map(res => res.json())
            .toPromise()
            .catch(error => console.log(error));
    }

    callEsProxy(term: string, resultsAmount: number = 15) {
        const request = '{"query": {"function_score": {"query": {"multi_match": {"query":"' + term
            + '","type":"best_fields","fields":["title","display_name","parrot_id","data.also_known_as^1.3"],"minimum_should_match":1,"fuzziness":1,"prefix_length":3,"slop":3}},"functions": [{"weight":1.0}],"score_mode":"sum"}},"timeout":"7s","_source": ["title","parrot_id","display_name","catalog_state","internal_data", "data.release_year", "data.original_country"]'
            + ',"size":' + resultsAmount + '}';
        const url = this.getESProxyUrl('master_tv_catalog');
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        const options = new RequestOptions({headers: headers});
        return this.http.post(url, request, options)
            .map(res => res.json())
            .toPromise()
            .catch(error => console.log(error));
    }

    callEsProxyForParrotIds(parrotIds: string[], source: string[] = ['parrot_id', 'title']) {
        const parrotIdMatchArray = parrotIds.map((parrotId) => {
            return {
                match: {
                    parrot_id: parrotId
                }
            };
        });
        const elasticSearchQuery = {
            'query': {
                'bool': {
                    'must': {
                        'bool': {
                            'should': parrotIdMatchArray
                        }
                    }
                }
            },
            '_source': source,
            'size': parrotIdMatchArray.length,
        };
        console.log(JSON.stringify(elasticSearchQuery));
        return this.callEsProxyCustomQuery(JSON.stringify(elasticSearchQuery));
    }

    callEsProxyForParrotIdsUsingIndex(parrotIds: string[], source: string[] = ['parrot_id', 'title'], index) {
        const parrotIdMatchArray = parrotIds.map((parrotId) => {
            return {
                match: {
                    parrot_id: parrotId
                }
            };
        });
        const elasticSearchQuery = {
            'query': {
                'bool': {
                    'must': {
                        'bool': {
                            'should': parrotIdMatchArray
                        }
                    }
                }
            },
            '_source': source,
            'size': parrotIdMatchArray.length,
        };
        console.log(JSON.stringify(elasticSearchQuery));
        return this.callEsProxyCustomQuery(JSON.stringify(elasticSearchQuery), index);
    }

    checkIfPresentInDailyInfohashes(parrotId: string) {
        const url = this.getBaseUrl() + this.DAILY_INFOHASH_CHECK_URL + '?parrotId=' + parrotId;
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        const options = new RequestOptions({headers: headers});
        return this.http.get(url, options)
            .map(res => res.json())
            .toPromise();
    }

    addToDailyInfohashes(parrotId: string) {
        const url = this.getBaseUrl() + this.DAILY_INFOHASH_CHECK_URL + '/add?parrotId=' + parrotId;
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        const options = new RequestOptions({headers: headers});
        return this.http.post(url, {}, options)
            .map(res => res.json())
            .toPromise();
    }

    removeFromDailyInfohashes(parrotId: string) {
        const url = this.getBaseUrl() + this.DAILY_INFOHASH_CHECK_URL + '/remove?parrotId=' + parrotId;
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        const options = new RequestOptions({headers: headers});
        return this.http.post(url, {}, options)
            .map(res => res.json())
            .toPromise();
    }

    mapGlobalSearchEsResultItem(item) {


        return {
            title: item._source.display_name ? item._source.display_name : '',
            displayName: item.highlight && item.highlight.display_name ? item.highlight.display_name[0] : item._source.display_name,
            displayNameTitle: item._source.display_name ? item._source.display_name : '',
            releaseYear: item._source.data && item._source.data.release_year ? item._source.data.release_year : '',
            parrotId: item._source.parrot_id,
            catalogType: item._source ? item._source.catalog_type : '',
            catalogState: item._source ? item._source.catalog_state : '',
            originalNetwork: item._source.data && item._source.data.original_network ? item._source.data.original_network['0'] : '',
            originalCountry: item._source.data && item._source.data.original_country ? item._source.data.original_country['0'] : '',
            also_known_as: item._source.data && item._source.data.also_known_as ? item._source.data.also_known_as.map(item => item).join(', ') : '',

        };
    }

    mapBusinessOperationsResultItem(item) {

        return {
            business_question: item._source.business_question,
            industry_segment: item._source.industry_segment,
            chart_names: item._source.chart_names,
            id: item._id,
        };
    }

    mapJustwatchEsResults(item) {

        return {
            justwatch_id: item._source.justwatch_id,
            content_type: item._source.content_type,
            title: item._source.originalTitle,
            original_release_date: item._source.original_release_date,
        };
    }

    mapJustwatchResultItem(item) {

        return {
            justwatch_id: item.justwatch_id,
        };
    }

    mapInternalMetadataResultItem(item, contentType) {
        console.log(item);

        return {
            parrotId: item._source.parrot_id,
            catalogState: item._source.catalog_state ? item._source.catalog_state : '',
            contentType: contentType,
            collapsed: false,
            checked: false,
            active: false,
        };
    }

    mapEsMetadataResultItem(item, contentType) {
        console.log(item);
        if (contentType !== 'movie') {
            return {
                parrotId: item._source.parrot_id,
                title: item._source.title,
                displayName: item._source.display_name ? item._source.display_name : item._source.title,
                catalogState: item._source.catalog_state ? item._source.catalog_state.toLowerCase() : '',
                releaseYear: item._source.data.release_year ? item._source.data.release_year : '',
                birthYear: item._source.data.birth_year ? item._source.data.birth_year : '',
                originalCountry: item._source.data.original_country ? (CommonUtils.getObjectValuesArray(item._source.data.original_country))[0] : '',
                originalNetwork: item._source.data.original_network ? (CommonUtils.getObjectValuesArray(item._source.data.original_network))[0] : '',
                originalLanguage: item._source.data.original_language ? (CommonUtils.getObjectValuesArray(item._source.data.original_language))[0] : '',
                productionCompany: item._source.data.production_company ? (CommonUtils.getObjectValuesArray(item._source.data.production_company))[0] : '',
                imdbId: item._source.data.external_mappings ? item._source.data.external_mappings.imdb_id  : '',
                genreTags: item._source.data.genre_tags ? item._source.data.genre_tags : [],
                totalSeasons: item._source.data.total_seasons ? item._source.data.total_seasons : null,
                totalEpisodes: item._source.data.total_episodes ? item._source.data.total_episodes : null,
                shortDescription: item._source.data.short_description,
                akas: item._source.data.also_known_as ? item._source.data.also_known_as : '',
                verificationStatus: item._source.verification_status ? item._source.verification_status.status : 'SYSTEM_VERIFIED',
                ...(contentType !== 'sports' && { sports: item._source.data.sports ? item._source.data.sports : null }),

                contentType: item._source.data.type ? item._source.data.type : contentType,
                collapsed: false,
                checked: false,
                active: false,
                externalMappings: item._source.data.external_mappings ? item._source.data.external_mappings : null,
                priority: item._source.internal_data && item._source.internal_data.priority ? item._source.internal_data.priority.toLowerCase() : 'none'
            };
        } else {
            return {
                parrotId: item._source.parrot_id,
                title: item._source.title,
                displayName: item._source.display_name ? item._source.display_name : item._source.title,
                catalogState: item._source.catalog_state ? item._source.catalog_state.toLowerCase() : '',
                releaseYear: item._source.data.release_year ? item._source.data.release_year : '',
                birthYear: item._source.data.birth_year ? item._source.data.birth_year : '',
                originalCountry: item._source.data.original_country ? item._source.data.original_country[0] ? item._source.data.original_country[0].value : '' : '',
                originalLanguage: item._source.data.original_language ? item._source.data.original_language[0] ? item._source.data.original_language[0].value : '' : '',
                originalNetwork: item._source.data.production_company ? item._source.data.production_company[0] ? item._source.data.production_company[0].value : '' : '',
                distributionCompany: item._source.data.distribution_company ? item._source.data.distribution_company[0] ? item._source.data.distribution_company[0].value : '' : '',
                genreTags: item._source.data.genre_tags ? item._source.data.genre_tags : [],
                totalSeasons: item._source.data.total_seasons ? item._source.data.total_seasons : null,
                totalEpisodes: item._source.data.total_episodes ? item._source.data.total_episodes : null,
                shortDescription: item._source.data.short_description,
                akas: item._source.data.also_known_as ? item._source.data.also_known_as : '',
                imdbId: item._source.data.external_mappings ? item._source.data.external_mappings.imdb_id  : '',
                verificationStatus: item._source.verification_status ? item._source.verification_status.status : 'SYSTEM_VERIFIED',
                sports: item._source.data.sports ? item._source.data.sports : null,

                contentType: item._source.data.type ? item._source.data.type : contentType,
                collapsed: false,
                checked: false,
                active: false,
                externalMappings: item._source.data.external_mappings ? item._source.data.external_mappings : null,
                priority: item._source.internal_data && item._source.internal_data.priority ? item._source.internal_data.priority.toLowerCase() : 'none'
            };
        }
    }

    mapEsResultItem(item) {
        console.log(item);

        return {
            parrotId: item._source.parrot_id,
            title: item._source.title,
            displayName: item._source.display_name ? item._source.display_name : item._source.title,
            catalogState: item._source.catalog_state ? item._source.catalog_state : '',
            releaseYear: item._source.data.release_year ? item._source.data.release_year : '',
            originalCountry: item._source.data.original_country ? item._source.data.original_country['0'] : '',
            originalNetwork: item._source.data.original_network ? item._source.data.original_network['0'] : '',
            originalLanguage: item._source.data.original_language ? item._source.data.original_language['0'] : '',
            genreTags: item._source.data.genre_tags ? item._source.data.genre_tags : [],
            totalSeasons: item._source.data.total_seasons ? item._source.data.total_seasons : null,
            totalEpisodes: item._source.data.total_episodes ? item._source.data.total_episodes : null,
            shortDescription: item._source.data.short_description,
            akas: item._source.data.also_known_as ? item._source.data.also_known_as : '',
            collapsed: false,
            checked: false,
            active: false,
            externalMappings: item._source.data.external_mappings ? item._source.data.external_mappings : null,
            priority: item._source.internal_data && item._source.internal_data.priority ? item._source.internal_data.priority.toLowerCase() : 'none'
        };
    }

    mapEsImdbResultItem(item) {
        return {
            title: item._source.Title,
            displayName: item._source.Title,
            catalogState: null,
            releaseYear: item._source.Year ? item._source.Year : '',
            originalCountry: item._source.Countries && item._source.Countries.Country ? item._source.Countries.Country[0] : '',
            originalNetwork: item._source.ProductionCompanies && item._source.ProductionCompanies.ProductionCompany ? item._source.ProductionCompanies.ProductionCompany[0] : '',
            shortDescription: item._source.PlotSummary ? item._source.PlotSummary : '',
            // tslint:disable-next-line:no-shadowed-variable
            akas: item._source.AKAs && item._source.AKAs.aka ? item._source.AKAs.AKA.map(item => item.title).join(', ') : '',
            collapsed: false,
            checked: false,
            active: false,
            imdb: true,
            imdbId: item._source.ResourceId,
            link: `https://www.imdb.com/${item._source.ResourceId.includes('tt') ? 'title' : 'name'}/${item._source.ResourceId}`
        };
    }

    getMappings(titleId: string, source: string, page: number) {
        const url = this.getBaseUrl() + this.DATAHEALTH_MAPPINGS_URL +
            `?titleId=${titleId}&source=${source}&page=${page}`;
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        const options = new RequestOptions({headers: headers});
        return this.http.get(url)
            .map(res => res.json())
            .toPromise();
    }

    putTitleNameChange(parrotId: string, title: string, newTitle: string) {
        const url = this.getBaseUrl() + this.TITLE_NAME_CHANGE_URL;
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        const options = new RequestOptions({headers});
        const payload = [
            {
                'parrot_id': parrotId,
                'title': title,
                'gene': 'title',
                'value': newTitle
            }
        ];
        return this.http.put(url, JSON.stringify(payload), options)
            .map(res => res.json())
            .toPromise();
    }

    getBittorenddtDate(selectedParrotId: string) {
        const url = this.getHelpdeskUrl() + '/cumulative_torrents/v2/datahealth/stats' +
            `?parrot_id=${selectedParrotId}`;
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        const options = new RequestOptions({headers: headers});
        return this.http.get(url, options)
            .map(res => res.json())
            .toPromise();
    }

    getCredits(selectedParrotId: string, contentType ) {

        if (contentType.toLowerCase() !== 'movie' && contentType.toLowerCase() !== 'talent') {
            contentType = 'SHOW';
        }
        const url = this.getHelpdeskUrl() + `/credits/v1/${contentType}/${selectedParrotId}`;
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        const options = new RequestOptions({headers: headers});
        return this.http.get(url, options)
            .map(res => res.json())
            .toPromise();
    }

    getBittorentDate(selectedParrotId: string) {

        // /entity/cb26aa53-b0f1-4ba6-a319-7d95dc630ec9/video?confidence_label=low&page=1&size=100&sort=total_number_of_views&sort_direction=ASC
        // tslint:disable-next-line:max-line-length
        const url = this.getHelpdeskUrl() + '/cumulative_torrents/v2/datahealth/stats' +
            `?parrot_id=${selectedParrotId}`;
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        const options = new RequestOptions({headers: headers});
        return this.http.get(url, options)
            .map(res => res.json())
            .toPromise();
    }

    private additionalFilterTermQuery(value: any, originalFilter: string) {
        const query = {
            'term': {
                [originalFilter]: value
            }
        };

        return query;
    }
}


// WEBPACK FOOTER //
// ./src/app/catalogue/catalog-api/catalog.service.ts